import moment from 'moment-timezone';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getPurchasesFeedbackList } from '../app/store/actions/purchaseFeedback';
import ModalComponent from '../components/modal';
import Table from '../components/table/table';

class PurchaseFeeback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'ASC',
      field: 'id',
      tableData: [],
      totalRecord: 0,
      showModal: false,
      selectItem: '',
      dataType: '',
      visibleModalMedianRating: false,
      ratings: [],
    };

    this.tableHeader = [
      { key: 'clientCode', value: 'Código Cliente' },
      { key: 'clientName', value: 'Nome Cliente' },
      { key: 'userCode', value: 'Código Usuário' },
      { key: 'userName', value: 'Nome Usuário' },
      { key: 'creationDate', value: 'Data Criação' },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    this.getPurchasesFeedbackList();
  }

  getPurchasesFeedbackList = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;

    const skip = (page - 1) * limit;

    const { count = 0, rows = [], ratings = [] } = await this.props.getPurchasesFeedbackList(
      limit, skip, search, orderBy, field,
    );

    await this.adjustData(count, rows, ratings);
  }

  adjustData = async (count = 0, rows = [], ratings = []) => {
    const tableData = rows.map(element => ({
      key: element.id,
      clientCode: element.clientId,
      clientName: element.client.nickname,
      userCode: element.userId,
      userName: element.user.name,
      creationDate: moment(element.createdAt).format('L LTS'),
      action: (
        <div className="row margin-left-0">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => this.selectPurchaseFeedback(element, 'feedback')}
          >
            {I18n.t('visualize')}
          </button>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      tableData,
      ratings,
    });
  }

  selectPurchaseFeedback = async (item, type) => {
    await this.setState({
      selectItem: item,
      showModal: true,
      dataType: type,
    });
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getPurchasesFeedbackList();
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getPurchasesFeedbackList();
  }

  showModalMedianRating = () => this.setState({ visibleModalMedianRating: true, dataType: 'ratings' })

  render() {
    const {
      limit, page, tableData, totalRecord,
      dataType, showModal, selectItem, visibleModalMedianRating,
      ratings,
    } = this.state;

    const { companyTag } = this.props;

    const tableButtons = (
      <React.Fragment>
        <button
          onClick={this.showModalMedianRating}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          {/* <Translate value="generateCSV" /> */}
          {I18n.t('feedbackMedianRating')}
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        {selectItem && showModal && (
          <ModalComponent
            id="purchasesFeedback"
            type={dataType}
            visible={showModal}
            titleModal={false}
            bodyModal={false}
            items={selectItem}
            showCancel={false}
            titleOkButtoonModal={I18n.t('ok')}
            closeModal={() => this.setState({ showModal: false })}
            size={{ width: '600px', height: 'auto' }}
          />
        )}

        {companyTag === 'nortel' && visibleModalMedianRating && (
          <ModalComponent
            id="purchasesFeedback"
            type={dataType} // ratings
            visible={visibleModalMedianRating}
            titleModal={false}
            bodyModal={false}
            items={ratings}
            showCancel={false}
            titleOkButtoonModal={I18n.t('ok')}
            closeModal={() => this.setState({ visibleModalMedianRating: false })}
            size={{ width: '600px', height: '430px' }}
          />
        )}

        <Table
          title={I18n.t('purchaseFeedback')}
          header={this.tableHeader}
          buttons={tableButtons}
          lines={tableData}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({ companyTag: state.settings && state.settings.companyTag });

const mapDispatchToProps = dispatch => ({
  getPurchasesFeedbackList: (limit, skip, search, orderBy, field) => dispatch(
    getPurchasesFeedbackList(limit, skip, search, orderBy, field),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseFeeback);
